module.exports = [
    // "www.agoda.com",
    // "www.avvo.com",
	// "www.expedia.com",
	"www.facebook.com",
	"www.google.com",
	// "www.playstore.com",
	// "www.tripadvisor.com",
	"www.yelp.com",
	// "www.zillow.com",
	// "www.zomato.com",
	// "www.airbnb.com",
	// "www.aliexpress.com",
	// "www.alternativeto.com",
	// "www.amazon.com",
	// "www.angi.com",
	// "www.apartmentratings.com",
	// "www.apartments.com",
	// "www.appstore.com",
	// "www.bbb.org",
	// "www.bookatable.co.uk",
	// "www.booking.com",
	// "www.capterra.com",
	// "www.cargurus.com",
	// "www.cars.com",
	// "www.citysearch.com",
	// "www.classpass.com",
	// "www.consumeraffairs.com",
	// "www.creditkarma.com",
	// "www.customerlobby.com",
	// "www.dealerrater.com",
	// "www.ebay.com",
	// "www.edmunds.com",
	// "www.etsy.com",
	// "www.findlaw.com",
	// "www.foursquare.com",
	// "www.g2crowd.com",
	// "www.gartner.com",
	// "www.glassdoor.com",
	// "www.greatschools.org",
	// "www.healthgrades.com",
	// "www.homeadvisor.com",
	// "www.homeaway.com.au",
	// "www.homestars.com",
	// "www.houzz.com",
	// "www.hotels.com",
	// "www.indeed.com",
	// "www.influenster.com",
	// "www.insiderpages.com",
	// "www.itcentralstation.com",
	// "www.lawyers.com",
	// "www.lendingtree.com",
	// "www.martindale.com",
	// "www.niche.com",
	// "www.openrice.com",
	// "www.opentable.com",
	// "www.producthunt.com",
	// "www.productreview.com.au",
	// "www.ratemds.com",
	// "www.reserveout.com",
	// "www.sitejabber.com",
	// "www.softwareadvice.com",
	// "www.talabat.com",
	// "www.theknot.com",
	// "www.thumbtack.com",
	// "www.trulia.com",
	// "www.trustedshops.com",
	// "www.trustpilot.com",
	// "www.trustradius.com",
	// "www.vitals.com",
	// "www.walmart.com",
	// "www.webmd.com",
	// "www.weddingwire.com",
	// "www.yell.com",
	// "www.yellowpages.com",
	// "www.zocdoc.com",
];